<template>
<div class="join-base" >
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</div>
</template>

<script>

export default {
  name: "Join",

}
</script>

<style lang="less" scoped>
.join-base{
  width: 100%;
  .join-image{
    img{
      width: 100%;
      height: 250px;
      object-fit: cover;
    }
  }
  .join-content{
    margin-top: 20px;
    padding-bottom: 10px;
  }
}
</style>